import { Typography, Tooltip } from "antd";
import TrustCenterCard from "./TrustCenterCard";

const { Title, Paragraph } = Typography;

export default function SubprocessorCard({ subprocessor }) {
  const shouldShowTooltip = subprocessor.name.length > 32;

  return (
    <TrustCenterCard style={{}} bodyStyle={{}}>
      <div
        style={{
          width: "64px",
          height: "64px",
          backgroundColor: "white",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "8px",
        }}
      >
        <img
          src={subprocessor.logo}
          alt={subprocessor.name}
          style={{
            maxWidth: "45px",
            maxHeight: "45px",
            borderRadius: "5px",
          }}
        />
      </div>
      {shouldShowTooltip ? (
        <Tooltip title={subprocessor.name} placement="top">
          <Title
            level={4}
            style={{
              marginTop: "0px",
              marginBottom: "8px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {subprocessor.name}
          </Title>
        </Tooltip>
      ) : (
        <Title
          level={4}
          style={{
            marginTop: "0px",
            marginBottom: "8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          {subprocessor.name}
        </Title>
      )}
      <Paragraph
        style={{
          color: "#666",
          fontSize: "14px",
          margin: 0,
          flex: 1,
        }}
      >
        {subprocessor.description}
      </Paragraph>
    </TrustCenterCard>
  );
}
